import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import NotFoundPage from "../pages/Fytn/components/NotFound";

const AdminRoute = ({ element }) => {
  const user = Cookies.get("fytn_user");
  const userObj = user ? JSON.parse(user) : null;
  if (userObj?.userRole === "ADMIN") {
    return element;
  } else {
    return <NotFoundPage />;
  }
};

export default AdminRoute;
